import { buildConversionBody, buildExtra, parseStoredUtm, parseUrlUtm, resolveAc, resolveActualAgentId, stripAuthParams } from './conversionPayload'

export const generateUniqId = (cryptoObj = globalThis.crypto) => {
  if (typeof cryptoObj?.randomUUID === 'function') return cryptoObj.randomUUID()
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`
}

// UTM 為選配 enrichment:隱私模式下 localStorage 讀取可能拋 SecurityError,不得中止送出
// TI-15642:網址優先於 stored（last-click）,命中即整包取代,與 Umami identify 的 buildUtmData 同語意
const readOptionalUtm = (deps) => {
  try {
    return parseUrlUtm(deps.getHref?.()) || parseStoredUtm(deps.getStoredUtmRaw())
  } catch {
    return undefined
  }
}

export const createConversionSender = (deps) => {
  return async ({ event, payload, eventId, attribution }) => {
    try {
      const { cookies } = deps
      const traceId = attribution ? attribution.traceId : cookies.get('conv_trace_id') || undefined
      if (!traceId) return

      const apiBase = deps.getApiBase()
      if (!deps.site || !apiBase) return

      const token = deps.getToken()
      const usingLaunchSnapshot = typeof attribution?.hadTokenAtLaunch === 'boolean'
      const authed = usingLaunchSnapshot ? attribution.hadTokenAtLaunch && !!token : !!token
      const userInfo = (authed && deps.getUserInfo()) || {}
      const agentId = authed ? userInfo.agent_id : undefined

      const ac = String(resolveAc({ attribution, cookieAc: cookies.get('conv_ac') || undefined, authed, agentId }))
      const capturedAtRaw = cookies.get('conv_captured_at')
      const capturedAt = attribution ? attribution.capturedAt : capturedAtRaw ? Number(capturedAtRaw) : undefined

      const body = buildConversionBody({
        traceId,
        vendorCode: attribution ? attribution.vendorCode : cookies.get('conv_vendor') || undefined,
        capturedAt,
        eventTime: usingLaunchSnapshot ? attribution.eventTime : deps.now(),
        eventId,
        uniqId: generateUniqId(),
        event,
        ac,
        actualAgentId: resolveActualAgentId({ authed, agentId, ac }),
        price: attribution ? attribution.price : cookies.get('conv_price') || undefined,
        externalId: authed ? userInfo.uid_site : undefined,
        site: deps.site,
        fbc: cookies.get('_fbc') || undefined,
        fbp: cookies.get('_fbp') || undefined,
        ttp: cookies.get('_ttp') || undefined,
        eventSourceUrl: stripAuthParams(deps.getHref()),
        extra: buildExtra(payload),
        utm: readOptionalUtm(deps),
      })

      const endpoint = authed ? 'events' : 'public-events'
      const baseUrl = apiBase.replace(/\/$/, '')
      const url = `${baseUrl}/v2/${deps.site}/conversion/${endpoint}?appSecret=${encodeURIComponent(deps.appSecret)}`

      await deps.fetchImpl(url, {
        method: 'POST',
        keepalive: true,
        headers: {
          'Content-Type': 'application/json',
          'X-TH1GAMES-VERSION': `v${deps.appVersion}`,
          'X-TH1GAMES-PLATFORM': 'pwa',
          ...(authed ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(body),
      })
    } catch (error) {
      if (deps.isDevLike) console.warn('[Conversion] send failed:', error)
    }
  }
}
